import { SET_EVENTS, SET_EVENT } from "../actionTypes"

const initialState = {
  eventsObject: {},
  events: [],
  event: {}
}

const eventsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_EVENTS:
      return {
        ...state,
        events: action.events.data,
        eventsObject: action.events
      }
    case SET_EVENT:
      return {
        ...state,
        event: action.event,
      }
    default:
      return state
  }
}

export default eventsReducer